import styled from "styled-components";

export const EBikesWraper = styled.div`

  height: 100%;
  padding-top: 8em;
  animation: fadeIn 2s;
  background: var(--clr-background);

  .ebike_wrapper{

    width: 95%;
    height: auto;
    margin: auto;
    padding: 15px;
    text-align: center;
    
  }


  .title_wrapper{

    height: auto;
    width: auto;
    padding: 8em 0px 5em;
    background: var(--clr-accent);
    border-radius: 25px 0px 25px 0px;

    h1{margin: 20px;}





}




`